import appdevelopmentone from "../assets/appdevelopment/appdevimageone.jpeg";
import appdevelopmenttwo from "../assets/appdevelopment/appdevimagetwo.jpeg";
import appdevelopmentthree from "../assets/appdevelopment/appdevimagethree.jpeg";

// import appdevelopmentthree from "../assets/icons/appdevelopmentthree.jpg";

const AppDevelopment = [
  {
    icon: appdevelopmentone,
    // path: "Web-Development",
  },

  {
    icon: appdevelopmenttwo,
    // path:"Digital-Marketing"
  },

  {
    icon: appdevelopmentthree,
    // path:"Web-Services"
  },
];

export default AppDevelopment;
